import { FieldError } from 'react-hook-form'

/**
 * The single rule for when an input shows its error. A `required` error is only
 * meaningful once the form is submitted — it must never surface while typing,
 * where it lingers stale from the empty state (RHF only re-validates on blur).
 * Other (format) errors show once the field is touched and non-empty. Returns
 * the message to display, or undefined to suppress.
 */
export const visibleError = (
  error: FieldError | undefined,
  {
    isTouched,
    isEmpty,
    isSubmitted,
  }: { isTouched: boolean; isEmpty: boolean; isSubmitted: boolean },
): string | undefined => {
  if (!error?.message) return undefined
  if (error.type === 'required') return isSubmitted ? error.message : undefined
  return (isTouched && !isEmpty) || isSubmitted ? error.message : undefined
}

/**
 * Renders an input's validation error as Group footer content with destructive
 * styling. Pass the message from `visibleError`; gate rendering on it at the
 * call site (`message ? <ErrorFooter message={message} /> : footer`) so the
 * Group's footer short-circuit still hides an empty footer when there's no
 * error.
 */
export const ErrorFooter = ({ message }: { message: string }) => (
  <span className="whitespace-pre-line text-error">{message}</span>
)
